import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="plug" {...props} />;
}

export const meta = {
  id: 'CMSIntegrations',
  title: 'CMSIntegrations',
  category: 'CMS',
  exposes: [
    // {
    //   title: 'General',
    //   action: { module: 'CMSIntegrations', props: { /* */ } },
    //   desription: 'general-desc',
    // },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `The integrations a tenant can have within the CMS tools`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 900,
    height: 560
  }
};
